// @flow
import React from 'react'
import { Stink } from 'components/Stink'
import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import './styles.scss'

export class Section2 extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
    }
    this.updateSizes = this.updateSizes.bind(this)
  }

  updateSizes() {
    this.setState({
      isMobile: window.innerWidth < 711
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateSizes)
    this.updateSizes()
  }

  render() {
    return <div className='section two' style={{colorScheme: this.props.colorMode === 'dark' ? 'dark' : 'light'}}>
      <div className="wrapper">
        <h2>C'est ici que vivent le plus de chiens</h2>
            <div className='txt'>
              <p>
                Les chiens sont appréciés dans toute la Suisse. Il existe toutefois des différences régionales. Si l'on calcule le nombre d'animaux par habitant et habitante, on remarque que ce sont surtout les personnes vivant dans des communes rurales qui possèdent le plus souvent des chiens. Cet animal de compagnie semble par ailleurs être un peu plus apprécié en Suisse latine qu'en Suisse alémanique. Le Jura et le Tessin se révèlent être de véritables hotspots canins.
              </p>
            </div>
            <div className="chart big">
              <AutofitIFrame
                src={'https://datawrapper.dwcdn.net/pSO6h/1/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
              />
            </div>

            <div className="chart">
              <AutofitIFrame
                src={'https://datawrapper.dwcdn.net/97m1x/4/' + '?transparent=true' + '&dark=' + String(this.props.colorMode === 'dark')}
              />
            </div>
      
          <div className='txt'>
            <p>
              C’est à Treytorrens, dans le canton de Vaud, qu'il y a de loin le plus d'animaux pour 100 habitants et habitantes: on y trouve presque autant de chiens que d'humains. Il s'agit pour la plupart d'épagneuls du Tibet, car il y a un élevage de cette race dans la commune.
            </p>
            <p>
              Genève est également un haut lieu en termes de chiens. Certes, on ne compte que 5 animaux pour 100 habitants et habitantes, mais dans cette commune les chiens vivent dans un espace très restreint. On y trouve ainsi 645 chiens par kilomètre carré. C’est nettement plus que dans toutes les autres communes de Suisse.
            </p>
          </div>

      </div>
    </div>
  }
}
